import React from 'react';
import {
	makeStyles,
	Grid,
	Paper,
	useMediaQuery,
	useTheme,
} from '@material-ui/core';
// import HeadlineText from '../reusableComponents/HeadlineText';
// import TitleText from '../reusableComponents/TitleText';
// import BlogSwipeView from '../reusableComponents/BlogsSwipeableView';
// import MobileBlogsSwipe from '../reusableComponents/MobileBlogsSwipe';
import LeftArrowBlueIcon from '../assets/images/LeftArrowBlueIcon.svg';
import RightArrowBlueIcon from '../assets/images/RightArrowBlueIcon.svg';

const useStyles = makeStyles((theme) => ({
	mainContainer: {
		marginTop: 50,
		height: 'unset',
		[theme.breakpoints.up('sm')]: {
			marginTop: 60,
		},
		[theme.breakpoints.up('md')]: {
			marginTop: 100,
		},
		[theme.breakpoints.up('lg')]: {
			marginTop: 80,
		},
		[theme.breakpoints.up('xl')]: {
			// height: '50vh',
		},
	},
	top: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		[theme.breakpoints.up('sm')]: {
			display: 'flex',
			flexDirection: 'row',
			justifyContent: 'space-between',
			alignItems: 'center',
		},
		[theme.breakpoints.up('md')]: {},
	},
	titleTextcontainer: {
		marginBottom: 16,
		textAlign: 'center',
		[theme.breakpoints.up('sm')]: {
			textAlign: 'left',
		},
	},
	arrowContainerWrapper: {
		width: '90%',
		marginTop: 10,
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		[theme.breakpoints.up('sm')]: {
			width: '30%',
		},
		[theme.breakpoints.up('md')]: {
			width: '15%',
		},
	},
	arrowContainer: {
		width: 60,
		height: 50,
		borderRadius: 10,
		boxShadow: '5px 5px 30px rgba(53, 98, 255, 0.15)',
		justifyContent: 'center',
		alignItems: 'center',
		display: 'flex',
		cursor: 'pointer',
	},
	bodyTextContainer: {
		width: '82%',
		[theme.breakpoints.down('sm')]: {
			width: '100%',
			textAlign: 'center',
		},
	},
}));

const BlogsSection = () => {
	const theme = useTheme();
	const matches = useMediaQuery(theme.breakpoints.down('sm'));
	const classes = useStyles();
	// const store = useSelector((state) => state);
	// const { ui, blogs } = store;
	const [stateIndex, setIndex] = React.useState(0);
	const [swipelimit, setSwipeLimit] = React.useState(0);

	// React.useEffect(() => {
	// 	if (blogs.allBlogs.length > 0) {
	// 		setSwipeLimit(blogs.allBlogs.length - 1);
	// 	}
	// }, [blogs.allBlogs]);
	// const handleLeftClick = () => {
	// 	if (stateIndex > 0) setIndex((prev) => prev - 1);
	// };
	// const handleRightClick = () => {
	// 	var limit = matches ? swipelimit : 2;
	// 	if (stateIndex < limit) setIndex((prev) => prev + 1);
	// };
	return (
		<Grid className={classes.mainContainer}>
			<Grid className={classes.top}>
				<Grid>
					<Grid className={classes.titleTextcontainer}>
						{/* <TitleText
							textStyle={{
								color: theme.palette.primary.main,
							}}
							two>
							{ui.landingPage.blogsSection.smallText}
						</TitleText> */}
					</Grid>
					<Grid className={classes.titleTextcontainer}>
						{/* <HeadlineText one>
							{ui.landingPage.blogsSection.mainText}
						</HeadlineText> */}
					</Grid>
				</Grid>
				<Grid className={classes.arrowContainerWrapper}>
					{/* <Paper className={classes.arrowContainer} onClick={handleLeftClick}> */}
					<img src={LeftArrowBlueIcon} alt='left-arrow-blue' />
					{/* </Paper> */}
					{/* <Paper className={classes.arrowContainer} onClick={handleRightClick}> */}
					<img src={RightArrowBlueIcon} alt='Right-arrow-blue' />
					{/* </Paper> */}
				</Grid>
			</Grid>
			{/* {matches ? (
				<MobileBlogsSwipe swipeIndex={stateIndex} />
			) : (
				<BlogSwipeView swipeIndex={stateIndex} />
			)} */}
		</Grid>
	);
};

export default BlogsSection;
